<div class="flex flex-col justify-between rounded-xl border border-gray-200 bg-white p-5 h-full min-h-[120px]">
  <!-- Header -->
  <div class="flex items-center justify-between">
    <p class="text-[16px] text-[#848484]">
      {{ title }}
    </p>

    @if (showFilter) {
    <button type="button" [matMenuTriggerFor]="filterOptions.length ? filterMenu : null"
      class="flex items-center gap-1 rounded-md border border-gray-200 px-3 py-1 text-xs text-gray-600 hover:bg-gray-50">
      {{ selectedFilter?.label || filterLabel }}
      <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 9-7 7-7-7" />
      </svg>
    </button>
    }
  </div>

  <!-- Value -->
  <p class="mt-10 text-[24px] font-semibold text-[#545454]">
    {{ display }}
  </p>
</div>

<mat-menu class="!rounded-md !bg-white !shadow-md" #filterMenu="matMenu">
  <div class="flex w-40 flex-col gap-2 p-2">
    @for (option of filterOptions; track option.value) {
    <button type="button" (click)="onFilterSelect(option)"
      class="flex w-full cursor-pointer items-center gap-2 rounded-md bg-[#F7F7F7] px-4 py-2 text-left text-sm hover:bg-gray-100">
      {{ option.label }}
    </button>
    }
  </div>
</mat-menu>